module.exports = __webpack_public_path__ + "img/55.852bf721.png";